import { organizationType } from "const/nuclias/organization";
import { userType } from "const/nuclias/user";
import { defaultTableColumn } from "./const";

// Service
import AuthOrganizationService from "services/Auth.Organization.service";
import AuthUserService from "services/Auth.User.service";

// Model
import AccountModel from "./models/Account";

const getSelectedOrg = (isOrgLevel, pageContext) => {
  let selectedOrg = null;

  if (!isOrgLevel) {
    selectedOrg = pageContext.sp || pageContext.si;
  } else {
    selectedOrg = pageContext.selectedOrg;
  }

  return selectedOrg;
}

export const getTableColumn = (orgType) => {
  if (orgType === organizationType.sp || orgType === organizationType.si) {
    return defaultTableColumn.sp;
  } else {
    return defaultTableColumn.org;
  }
}

const getAccountListData = async (orgId) => {
  const response = await AuthOrganizationService.fetchUserList(orgId);
  return response;
}

const parseRawData = (rawDataList, selectedOrg, orgTreeMap) => {
  let accountList = [];

  for (let rawData of rawDataList) {
    if (rawData.userType === 'GO') {
      return;
    }

    accountList.push(new AccountModel(rawData, selectedOrg, orgTreeMap));
  }

  return accountList;
}

const getUser = async (userId) => {
  const response = await AuthUserService.getUser(userId);
  return response;
}

const addOrSaveAccount = async (account, editUserId = null, updatedUserData = null) => {
  const newAccountData = {
    name: '',
    email: '',
    privilege: '',
    type: '',
    employerId: 0,
    resources: [],
  };

  newAccountData.id = account.id?.value ? account.id?.value : null;
  newAccountData.type = account.accessPrivilegeLevelType.selected.value;
  newAccountData.name = account.name.value;
  newAccountData.email = account.email.value;
  newAccountData.privilege = account.accessPrivilegeRole.selected.value;
  newAccountData.employerId = account.accessPrivilegeLevelOrg.selected.id;

  // SP
  if (newAccountData.type === organizationType.sp) {
    const managedSIList = account.managedMSP.list.filter(item => item.checked);

    if (account.managedMSP.list.length === managedSIList.length) {
      // manage SP
      newAccountData.resources.push({ id: newAccountData.employerId, type: organizationType.sp });
    } else {
      // manage MSP
      for (const managedSI of managedSIList) {
        if (managedSI.id !== 0) {
          newAccountData.resources.push({ id: managedSI.id, type: organizationType.si });
        }
      }
    }
  }

  // MSP
  if (newAccountData.type === organizationType.si) {
    // manage MSP
    newAccountData.resources.push({ id: newAccountData.employerId, type: organizationType.si });
  }

  // Organization
  if (newAccountData.type !== organizationType.sp && newAccountData.type !== organizationType.si) {
    if (account.managedSiteTag.selected.id === 0 && account.managedSite.selected.id === 0) {
      // manage Organization
      newAccountData.type = userType.org;
      newAccountData.resources.push({ id: newAccountData.employerId, type: organizationType.org });
    } else if (account.managedSiteTag.selected.id !== 0 && account.managedSite.selected.id === 0) {
      // manage Site tag
      newAccountData.type = userType.siteTag;
      newAccountData.resources.push({ id: account.managedSiteTag.selected.id, type: organizationType.tag });
    } else {
      // managee Site
      newAccountData.type = userType.site;
      newAccountData.resources.push({ id: account.managedSite.selected.id, type: organizationType.site });
    }
  }

  let updatedPrivilege = {};
  if (updatedUserData) {
    updatedUserData.name = newAccountData.name;
    updatedUserData.email = newAccountData.email;
    updatedPrivilege = {
      type: newAccountData.type,
      privilege: newAccountData.privilege,
      resources: newAccountData.resources
    }
  }

  let response = null;

  if (!editUserId) {
    response = await AuthUserService.postInviteUser(newAccountData);
  } else {
    response = await AuthUserService.updatePrivilege(editUserId, updatedPrivilege);

    if (response.error) {
      return response;
    }

    response = await AuthUserService.updateUser(editUserId, updatedUserData);
  }

  return response;
}

const getDeleteButtonState = (accountList) => {
  let canDelete = false;
  for (const account of accountList) {
    if (account.checked) {
      canDelete = true;
    }
  }

  return canDelete;
}

const getCheckAllState = (accountList) => {
  let checkedAll = true;

  if (accountList.length === 0) {
    return false;
  } else {
    for (const account of accountList) {
      if (!account.checked) {
        checkedAll = false;
      }
    }
  }

  return checkedAll;
}

const getDeleteAccountStatus = (user, accountList, status) => {
  let adminOrgNumber = 0;
  let checkedAdminOrgNumber = 0;

  for (const account of accountList) {
    account.checked && status.idList.push(account.id);

    // Finger out how many org admin accounts and be deleted org admin accounts
    account.rawData.type === userType.org && adminOrgNumber++;
    account.checked && account.rawData.type === userType.org && checkedAdminOrgNumber++;
  }

  status.oneAccount = status.idList.length === 1 ? true : false;
  status.notIncludedSelf = status.idList.indexOf(user.id) === -1 ? true : false;
  (user.isSelfRegistered && (adminOrgNumber === checkedAdminOrgNumber)) && (status.notLastOrgOrgAdmin = false);

  return status;
}

const toggleCheckedAll = (accountList) => {
  let nowState = getCheckAllState(accountList);

  const updatedAccountList = [...accountList];
  for (const account of updatedAccountList) {
    account.checked = !nowState;
  }

  return updatedAccountList;
}

const toggleChecked = (accountList, index) => {
  const updatedAccountList = [...accountList];
  updatedAccountList[index].checked = !updatedAccountList[index].checked;
  return updatedAccountList;
}

const resendEmail = async (userId, email) => {
  const response = await AuthUserService.postResend(userId, email);
  return response;
}

export default {
  getSelectedOrg,
  getTableColumn,
  getAccountListData,
  parseRawData,
  getUser,
  addOrSaveAccount,
  getDeleteButtonState,
  getDeleteAccountStatus,
  getCheckAllState,
  toggleCheckedAll,
  toggleChecked,
  resendEmail
}
